export function getCardLastDigits(cardNumber: string) {
  return '•••• ' + cardNumber.slice(-4);
}
